<template>
<div>
  <b-card-group deck>
    
    <b-card title="Qr de usuario a buscar" class="text-uppercase text-center">
      
        <qrcode-reader v-if="mostrar" @decode="onDecode"></qrcode-reader>
    </b-card>
    
  </b-card-group>
</div>
</template>
<script>
export default {
  name: "validate",
  components: {},
  create(){
  },
  mounted(){
    this.$store.dispatch('clearCredential').then(resolve=>{
      console.log('Limpiado ')
    })
  },
  data: function() {
    return {
      modalShow: true,
      selected: null,
      mostrar: true, 
      idSearch: "",
      options: [
        {
          value: null,
          text: "Seleccione validacion de credencial"
        },
        {
          value: 1,
          text: "Mediante codigo"
        },
        {
          value: 2,
          text: "Mediante QR"
        }
      ]
    };
  },
  methods: {
    setData: function(select) {
      console.log(select);
    },
    searchId: function() {
      console.log(this.idSearch);
      this.$store
        .dispatch("validateCredential", this.idSearch)
        .then(response => {
          console.log("respuesta", response);
        })
        .catch(err => {
          console.log("respuesta", err);
        });
    },
    onDecode: function(decode) {
      if(decode.length>2){
        let resp = this.$store.dispatch("validateCredential", decode);
        console.log("respuesta", resp);
        if (resp.code === 2) {
          this.$router.push({
            path: "external/request"
          });
        }
      }else{
        this.mostrar = false;
        setTimeout(()=>{
          this.mostrar = true;
        }, 200)
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/external/pedido/index.vue